export default "__VITE_ASSET__BESIGrW6__"